// A dismissed first-sign-in prompt stays quiet for this authenticated browser
// session. The marker contains only governed identifiers, never a token or an
// email address, and is cleared on explicit sign-out so the later-sign-in
// re-prompt remains server controlled.

const PREFIX = "vd-notification-prompt-deferred:";
const fallback = new Set();

function key(vendor, contactId) {
  return `${PREFIX}${encodeURIComponent(vendor)}:${encodeURIComponent(contactId)}`;
}

export function notificationPromptDeferred(vendor, contactId) {
  if (!vendor || !contactId) return false;
  const marker = key(vendor, contactId);
  try { return window.sessionStorage.getItem(marker) === "1"; }
  catch (_) { return fallback.has(marker); }
}

export function deferNotificationPrompt(vendor, contactId) {
  if (!vendor || !contactId) return;
  const marker = key(vendor, contactId);
  fallback.add(marker);
  try { window.sessionStorage.setItem(marker, "1"); } catch (_) { /* memory fallback */ }
}

export function clearNotificationPromptSession() {
  fallback.clear();
  try {
    const keys = [];
    for (let index = 0; index < window.sessionStorage.length; index += 1) {
      const candidate = window.sessionStorage.key(index);
      if (candidate?.startsWith(PREFIX)) keys.push(candidate);
    }
    keys.forEach(candidate => window.sessionStorage.removeItem(candidate));
  } catch (_) { /* blocked storage has only the memory fallback */ }
}
